module.exports = __webpack_public_path__ + "img/ico_download--white.183a8d8c.svg";